module.exports = __webpack_public_path__ + "img/email-preferences@2x.5ec5e499.png";